import React, { useEffect, useState } from "react";
import {
  getSupportCategories,
  removeSupportCategories,
} from "../../../Controllers/AppManagement/helpSupport";
import mainContext from "../../../contexts/mainContext";
import { __snackBarSeverity } from "../../../constants";
import moment from "moment";
import { Button, Divider } from "@mui/material";
import styled from "@emotion/styled";
import AddEditCategory from "./AddEditCategory";
import DeleteIcon from "@mui/icons-material/Delete";
export default function Categories() {
  const { setSnackBar, setProfileNavTitle } =
    React.useContext(mainContext); /* App State */
  const [state, setState] = useState({
    /* Component State */ supportCategory: [],
    openModal: false,
    selectedData: {},
    index: -1,
  });

  useEffect(() => {
    setProfileNavTitle("Help&Support"); /* Set TopNav Title */
    fetchCategories();
    // eslint-disable-next-line
  }, []);

  const callSnackBar = (msg, type) => {
    /* Alert for User */
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    });
  };

  const fetchCategories = async () => {
    /* Get Categories and sub categories */
    const res = await getSupportCategories();
    if (res.data.status === 200) {
      setState({ ...state, ...res.data.data });
    } else {
      callSnackBar(res.data.errors[0].message, "error");
    }
  };

  const handleAdd = (data) => {
    let temp = [...state.supportCategory];
    temp.push(data);
    setState({ ...state, supportCategory: temp, openModal: false });
  };

  const handleEdit = (data, index) => {
    let temp = [...state.supportCategory];
    temp[index] = data;
    setState({ ...state, supportCategory: temp, openModal: false });
  };

  const handleRemove = async (index, id) => {
    const res = await removeSupportCategories({ categoryId: id });
    if (res.data.status === 200) {
      callSnackBar(res.data.message, "success");
      let temp = [...state.supportCategory];
      temp.splice(index, 1);
      setState({ ...state, supportCategory: temp, openModal: false });
    } else {
      callSnackBar(res.data.errors[0].message);
    }
  };

  return (
    <>
      <Conatiner>
        <Header>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setState({
                ...state,
                openModal: true,
                selectedData: {},
                index: -1,
              });
            }}
          >
            Add new
          </Button>
        </Header>
        <Body>
          <List>
            <div className="header">Category</div>
            <div className="header">Sub-categories</div>
            <div>Updated On</div>
          </List>
          <Divider className="divider-gap" />
          {state.supportCategory.map((object, index) => {
            return (
              <List key={object._id}>
                <div>{object.category}</div>
                <div>
                  {object.subCategory.map((object1, index) => (
                    <span>
                      {object1.name}{" "}
                      {object.subCategory.length !== index + 1 && " , "}
                    </span>
                  ))}
                </div>
                <div>{moment(object.updatedAt).format("DD MMM, YYYY")}</div>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <DeleteIcon
                    className="pointer"
                    sx={{ marginRight: 2 }}
                    onClick={() => handleRemove(index, object._id)}
                  />
                  <button
                    className="list_card_view_btn"
                    onClick={() => {
                      setState({
                        ...state,
                        openModal: true,
                        selectedData: object,
                        index,
                      });
                    }}
                  >
                    Edit
                  </button>
                </div>
              </List>
            );
          })}
        </Body>
      </Conatiner>

      {/* Render Add/Edit Category Popup */}
      {state.openModal && (
        <AddEditCategory
          open={state.openModal}
          index={state.index}
          data={state.selectedData}
          onAdd={handleAdd}
          onEdit={handleEdit}
          handleClose={() => {
            setState({ ...state, openModal: false });
          }}
        />
      )}
    </>
  );
}

const Conatiner = styled("div")`
  .divider-gap {
    margin: 0.5rem 0;
  }
  button {
    text-transform: none;
  }
`;

const Header = styled("div")`
  button {
    border-radius: 5px;
  }
`;
const Body = styled("div")`
  height: 80vh;
`;

const List = styled("div")`
  .header {
    font-family: "semi-bold";
    font-size: 90%;
  }
  margin-top: 1rem;
  display: grid;
  grid-template-columns: 2fr 8fr 2fr 1fr;
  align-items: center;
  font-size: 14px;
`;
